module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-autocomplete', {
    attrs: {
      "size": "small",
      "popper-class": ("algolia-search" + (_vm.isEmpty ? ' is-empty' : '')),
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.placeholder,
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.item.category) ? _c('p', {
          staticClass: "algolia-search-title"
        }, [_c('span', {
          staticClass: "algolia-search-category",
          domProps: {
            "innerHTML": _vm._s(props.item.category)
          }
        }), _c('span', {
          staticClass: "algolia-search-separator"
        }, [_vm._v(">")]), _c('span', {
          domProps: {
            "innerHTML": _vm._s(props.item.content)
          }
        })]) : _vm._e(), (props.item.img) ? _c('a', {
          staticClass: "algolia-search-link",
          attrs: {
            "target": "_blank",
            "href": "https://www.algolia.com/docsearch"
          }
        }, [_c('img', {
          staticClass: "algolia-search-logo",
          attrs: {
            "src": require("./algolia.svg"),
            "alt": "algolia-logo"
          }
        })]) : _vm._e(), (props.item.img) ? _c('a', {
          staticClass: "algolia-search-link algolia-search-link-ele",
          attrs: {
            "target": "_blank",
            "href": "https://github.com/ElemeFE/element/blob/dev/examples/components/search.vue"
          }
        }, [_vm._v("\n      Thanks to Element UI.\n    ")]) : _vm._e(), (props.item.isEmpty) ? _c('p', {
          staticClass: "algolia-search-empty"
        }, [_vm._v(_vm._s(_vm.emptyText))]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47da4a36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-47da4a36","preserveWhitespace":false}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./src/algolia-search.vue
// module id = 287
// module chunks = 483